import React  from 'react';
import css from './styles.module.scss';
import { StepControls } from '~/common/step-controls';
import { useForm } from 'react-hook-form';
import { INewDealStepThreeFormInputs } from '~/models/deals/new-deal/formInputs';
import { Button, Grid, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { TextInput } from '~/features/dashboard/components/add-deal/components/text-input';

interface Step_6Props {
    prevStep: () => void;
}

export const Step_6: React.FC<Step_6Props> = ({ prevStep }) => {

    const {
        register,
    } = useForm<INewDealStepThreeFormInputs>({
        defaultValues: {},
    });

    // const onSubmit = useCallback(
    //     (data: INewDealStepThreeFormInputs) => {
    //         dispatch(data);
    //     },
    //     [dispatch]
    // );

    return (
        <div className={css.module}>
            <form className={css.form} >
                <Typography align={'left'} variant={'h6'} className={classNames(css.bold, css.title)}>
                    test - test the Statement Received
                </Typography>
                <Grid container spacing={3} className={css.container}>
                    <Grid item xs={12} className={css.box}>
                        <label className="customlabel bold">Statement Summary</label>
                    </Grid>

                    {/*Net Physical*/}
                    <Grid item xs={3} className={css.box}>
                        <label className="customlabel bold">Net Physical</label>
                    </Grid>
                    <Grid item xs={5} className={css.box}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={3} className={css.box}>
                        <Button className={css.button}>
                            Details
                        </Button>
                    </Grid>

                    {/*Net Digital*/}
                    <Grid item xs={3} className={css.box}>
                        <label className="customlabel bold">Net Digital</label>
                    </Grid>
                    <Grid item xs={5} className={css.box}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={3} className={css.box}>
                        <Button className={css.button}>
                            Details
                        </Button>
                    </Grid>

                    {/*Net Licensing*/}
                    <Grid item xs={3} className={css.box}>
                        <label className="customlabel bold">Net Digital</label>
                    </Grid>
                    <Grid item xs={5} className={css.box}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={3} className={css.box}>
                        <Button className={css.button}>
                            Details
                        </Button>
                    </Grid>

                    {/*Net Recoups*/}
                    <Grid item xs={3} className={css.box}>
                        <label className="customlabel bold">Net Recoups</label>
                    </Grid>
                    <Grid item xs={5} className={css.box}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                    <Grid item xs={3} className={css.box}>
                        <Button className={css.button}>
                            Details
                        </Button>
                    </Grid>

                    <Grid item xs={3} className={css.box}>
                        <label className="customlabel bold">Statement Total</label>
                    </Grid>
                    <Grid item xs={5} className={css.box}>
                        <TextInput
                            className={css.textInput}
                            label={''}
                            name={'usersRef'}
                            register={register}
                            // fieldError={errors.usersRef}
                        />
                    </Grid>
                </Grid>
                <StepControls onPrevClick={prevStep} className={css.nextButton} />
            </form>
        </div>
    );
};
